'use strict';

var throttle = require('lodash/throttle');

module.exports = function () {
    let previousScroll = 0;
    const $subNav = $('.sub-nav');
    const headerOrgOffset = $('.sub-nav-spacer') && $('.sub-nav-spacer').offset() ? $('.sub-nav-spacer').offset().top : null;
    const activeClass = 'active';

    /**
     * Function to toggle sub nav based on scroll position
     */
    function updateSubNavPosition() {
        const scrollPos = window.scrollY;
        if (scrollPos > headerOrgOffset && scrollPos > previousScroll) {
            if ($subNav.hasClass(activeClass)) {
                $subNav.removeClass(activeClass);
            }
        } else if (!$subNav.hasClass(activeClass)) {
            $subNav.addClass(activeClass);
        }
        previousScroll = scrollPos;
    }

    const throttleScroll = throttle(updateSubNavPosition, 100, { leading: true });

    if ($subNav && headerOrgOffset) {
        $(document).on('scroll', function () {
            throttleScroll();
        });
    }
};
